import React, { useMemo } from 'react';
import { LanguageEnum } from '../../constants';
import { getCurrentLanguage } from '../../LanguageHelper';
import './MaintenanceBlockingScreen.css';
import { HeaderWrapper } from '../../routes/Header/HeaderWrapper';
import Logo from '../../routes/Header/Logo';
import { UpperMenu } from '../../routes/Header/UpperMenu';

const MaintenanceBlockingScreen = ({
  dutchContent,
  frenchContent,
  englishContent,
  germanContent
}) => {
  const language = useMemo(() => getCurrentLanguage(), []);

  const renderSwitch = lang => {
    switch (lang) {
      case LanguageEnum.EN:
        return englishContent || '';
      case LanguageEnum.FR:
        return frenchContent || '';
      case LanguageEnum.DE:
        return germanContent || '';
      case LanguageEnum.NL:
        return dutchContent || '';
      default:
        return englishContent || '';
    }
  };

  return (
    <div className="MaintenanceBlockingScreen">
      <HeaderWrapper style={{ width: '100%' }}>
        <Logo />
        <div>
          <UpperMenu />
        </div>
      </HeaderWrapper>
      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        dangerouslySetInnerHTML={{ __html: renderSwitch(language) }}
      />
    </div>
  );
};

export default MaintenanceBlockingScreen;
